<template>
  <v-container fluid class="home-container">
    <v-carousel
      class="slider"
      :height="isDesktop() ? '70vh' : '280px'"
      hide-delimiter-background
      :hide-delimiters="!isDesktop()"
      cycle
      show-arrows-on-hover
    >
      <v-carousel-item v-for="(image, i) in images" :key="i">
        <img :src="image.image" align="center" class="slider-image" />
        <h2 class="image-title">{{ image.title }}</h2>
        <v-btn
          :href="image.link"
          depressed
          color="rgb(51,51,51)"
          style="color: rgb(255, 204, 0)!important;"
          class="learn-more-btn"
          light
          >LEARN MORE</v-btn
        >
      </v-carousel-item>
    </v-carousel>
    <br />
    <v-row class="fill-height" align="center" justify="center">
      <p class="subheading font-weight-regular" id="home-text">
        The Interaction Lab focuses on developing computational principles, techniques, models, and interventions to enable socially assistive human-robot interaction that supports human health and wellness. Socially Assistive Robotics (SAR) uses non-contact social interaction interventions involving social, emotional, cognitive, and physical abilities of users, toward improved wellness, communication, learning, and autonomy. The Interaction Lab conducts research in an interdisciplinary SAR arena that uses computing, engineering, and human user studies to <a class="link" href="/research/areas">characterize, model, and understand</a>
        complex human behavior. Our <a class="link" href="/research/projects">projects</a> aim to contribute insights and individualized tools toward mitigating pervasive societal challenges—including skill training for <a class="link" href="/research/domains">autism, anxiety, and depression coping, rehabilitation, and healthy aging</a>
        —that require sustained personalized support that supplement the efforts of caregivers, clinicians, parents, and educators.
      </p>
    </v-row>
    <v-row class="fill-height" align="center" justify="center">
      <v-btn
        large
        color="rgb(153,0,0)"
        style="color:white;"
        @click="$router.push({ name: 'Contact' })"
        >Get Involved!
      </v-btn>
    </v-row>
    <div class="invisible-images-for-cache">
      <img
        v-for="image in images"
        :key="image.title"
        :src="image.image"
        alt="should not be visible"
      />
    </div>
  </v-container>
</template>

<script>
// import { Carousel, Slide } from "vue-carousel";
import { getImages } from "../../service/home";

export default {
  //   components: {
  //     Carousel,
  //     Slide,
  //   },
  data() {
    return {
      images: [],
    };
  },
  mounted() {
    // get all images for sliders
    getImages()
      .then((collections) => {
        this.images = collections;
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
  methods: {
    isDesktop() {
      if (
        /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style lang="scss">
.slider-container {
  min-height: 600px;
}

.home-container {
  padding: 0;

  // introduction
  #home-text {
    width: 80%;
    font-family: "Open Sans", sans-serif !important;
    font-weight: 200 !important;
    font-size: 18px;
  }

  // slider
  .slider {
    background-color: rgba(0, 0, 0, 0.9);

    .slider-image {
      height: 100%;
      max-width: 100%;
      left: 50%;
      position: relative;
      transform: translateX(-50%);
    }

    // image title
    .image-title {
      position: absolute;
      left: 50%;
      bottom: 100px;
      color: white;
      transform: translate(-50%, 0);
      text-shadow: 1px 1px 2px black;
    }

    // learn more button
    .learn-more-btn {
      position: absolute;
      left: 50%;
      bottom: 60px;
      transform: translate(-50%, 0);
    }
  }

  // invisible image div for cache images
  .invisible-images-for-cache {
    display: none;
  }
}

/**
 * following are responsive support
 */
@media (max-width: 400px) {
  .home-container {
    .slider {
      //   height: 280px !important;

      .slider-image {
        width: 100%;
        left: 0;
        transform: none;
      }

      .image-title {
        font-size: 20px;
        width: 80%;
        text-align: center;
      }
    }

    // learn more button
    .learn-more-btn {
      bottom: 40px !important;
    }
  }
}
</style>
